import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import SimpleTable from '../../../../../core/components/simpleTables/SimpleTable';
import { Column } from 'primereact/column';
import Radio from '../../../../../core/components/inputs/radio/Radio';
import PTAFiplanIntegracaoService from '../../../../../service/integracao/PTAFiplanIntegracaoService';
import ProgramaIntegracaoService from '../../../../../service/integracao/ProgramaIntegracaoService';
import EixoIntegracaoService from '../../../../../service/integracao/EixoIntegracaoService';
import builder from '@rsql/builder';
import { emit } from '@rsql/emitter';

function TablePesquisar({ listaInputs, instrumento }, ref) {
    const tableRef = useRef(null);
    const [selected, setSelected] = useState(null);

    useImperativeHandle(
        ref,
        () => ({
            selected,
            onFiltro: tableRef.current?.onFiltro,
            setLista: (lista) => tableRef.current?.setLista(lista),
        }),
        [tableRef, selected]
    );

    return (
        <SimpleTable
            ref={tableRef}
            onFind={async (pagination) => {
                const { filters } = pagination;
                let responseList = [];
                let query = [];
                switch (instrumento?.codgInstrumento) {
                    case 'EIXO':
                        if (typeof pagination.filters?.search !== 'string') {
                            if (filters?.codigo) {
                                query.push(builder.comparison('codigoEixo', '==', filters?.codigo));
                            }

                            if (filters?.exercicio?.ano) {
                                query.push(
                                    builder.comparison(
                                        'exercicio.ano',
                                        '==',
                                        filters?.exercicio?.ano
                                    )
                                );
                            }

                            if (filters?.nome) {
                                query.push(builder.comparison('nomeEixo', '==', filters?.nome));
                            }
                            pagination.filters = {
                                search: emit(builder.and(...query)),
                            };
                        }
                        const responseEixo = await EixoIntegracaoService.pesquisar(pagination);
                        responseEixo.content = responseEixo.content.map(({ exercicio, ...el }) => ({
                            exercicio,
                            exercicioView: exercicio?.ano,
                            codigo: el?.codigoEixo,
                            nome: el?.nomeEixo,
                        }));
                        responseList = responseEixo;
                        break;
                    case 'PROGRAMA':
                        if (typeof pagination.filters?.search !== 'string') {
                            if (filters?.codigo) {
                                query.push(
                                    builder.comparison('codigoPrograma', '==', filters?.codigo)
                                );
                            }

                            if (filters?.exercicio?.ano) {
                                query.push(
                                    builder.comparison(
                                        'exercicio.ano',
                                        '==',
                                        filters?.exercicio?.ano
                                    )
                                );
                            }

                            if (filters?.nome) {
                                query.push(
                                    builder.comparison(
                                        'descricaoPrograma',
                                        '==',
                                        `*${filters?.nome}*`
                                    )
                                );
                            }
                            pagination.filters = {
                                search: emit(builder.and(...query)),
                            };
                        }
                        const responsePrograma = await ProgramaIntegracaoService.pesquisar(
                            pagination
                        );
                        responsePrograma.content = responsePrograma.content.map(
                            ({ exercicio, ...el }) => ({
                                exercicio,
                                exercicioView: exercicio?.ano,
                                codigo: el?.codigoPrograma,
                                nome: el?.descricaoPrograma,
                            })
                        );
                        responseList = responsePrograma;

                        break;
                    default:
                        if (typeof pagination.filters?.search !== 'string') {
                            if (filters?.codigo) {
                                query.push(
                                    builder.comparison('codigoElemento', '==', filters?.codigo)
                                );
                            }

                            if (filters?.exercicio?.ano) {
                                query.push(
                                    builder.comparison(
                                        'exercicio.ano',
                                        '==',
                                        filters?.exercicio?.ano
                                    )
                                );
                            }

                            if (filters?.nome) {
                                query.push(
                                    builder.comparison(
                                        'descricaoElemento',
                                        '==',
                                        `*${filters?.nome}*`
                                    )
                                );
                            }
                            pagination.filters = {
                                search: emit(builder.and(...query)),
                            };
                        }
                        const responsePTA = await PTAFiplanIntegracaoService.pesquisar(pagination);
                        responsePTA.content = responsePTA.content.map(({ exercicio, ...el }) => ({
                            exercicio,
                            exercicioView: exercicio?.ano,
                            codigo: el?.codigoElemento,
                            nome: el?.descricaoElemento,
                        }));
                        responseList = responsePTA;
                        break;
                }
                return responseList;
            }}
        >
            <Column
                header="Selecionar"
                body={({ codigo, ...rest }) => (
                    <Radio
                        onChange={() => {
                            setSelected({ ...rest, codigo });
                        }}
                        name="selecao"
                        value={codigo}
                        checked={selected?.codigo === codigo}
                    />
                )}
            />
            {listaInputs
                .filter((input) => input?.table?.use ?? false)
                .map((input, index) => (
                    <Column key={index} field={input?.name} header={input?.label} />
                ))}
        </SimpleTable>
    );
}

export default forwardRef(TablePesquisar);
